import { Layout as BaseLayout, useRequireOrganization } from '@startupquickstart/frontend';
import { Outlet } from 'react-router-dom';
import { AiJobNotificationProvider } from '../ai-job/AiJobNotificationProvider';
import { AnalyticsProvider } from '../analytics/AnalyticsProvider';
import { AppStandardSidebar } from '../AppStandardSidebar';
import { SidebarSetup } from '../SidebarSetup';
import { SupportButton } from '../support';
import { WhatsNewButton } from '../whats-new';

/**
 * Header action cluster: What's New + Support, separated by a divider.
 * Both buttons render null outside internal orgs, so the divider is gated
 * on the same condition to avoid a stray line for hotel users.
 */
function HeaderActions() {
  const { hasOrganization, isInternal } = useRequireOrganization();
  const showDivider = hasOrganization && isInternal;

  return (
    <div className="flex items-center gap-3">
      <WhatsNewButton />
      {showDivider && <div aria-hidden="true" className="h-6 w-px bg-border" />}
      <SupportButton />
    </div>
  );
}

export function Layout() {
  return (
    <>
      <SidebarSetup />
      <AnalyticsProvider />
      <AiJobNotificationProvider>
        <BaseLayout
          sidebar={<AppStandardSidebar />}
          headerActions={<HeaderActions />}
        >
          <Outlet />
        </BaseLayout>
      </AiJobNotificationProvider>
    </>
  );
}
